import React, { Component } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import "./marketingBar.scss"

class MarketingBar extends Component {
  generateLinks = (urls) => {
    return urls.map((link, index) => {
      return (
        <Link
          className="marketing-bar__split"
          key={index}
          to={link}
          onClick={() =>
            this.props.trackEvent("Banner", {
              link: link,
              image: this.props.image,
              location: this.props.location,
            })
          }
        />
      )
    })
  }

  singleBanner = (_) => {
    let { links, target } = this.props
    return (
      <div className="marketing-bar">
        <Link
          className="marketing-bar__link"
          to={links[0]}
          onClick={() =>
            this.props.trackEvent("Banner", {
              link: links[0],
              image: this.props.image,
              location: this.props.location,
            })
          }
        />
      </div>
    )
  }

  splitBanner = (_) => {
    let { links } = this.props
    return <div className="marketing-bar">{this.generateLinks(links)}</div>
  }

  render() {
    let { bannerType } = this.props

    return (
      <div
        className="marketing-bar-container"
        style={{ backgroundImage: `url(${this.props.image})` }}
      >
        {bannerType === "single" && this.singleBanner()}
        {bannerType === "split" && this.splitBanner()}
      </div>
    )
  }
}

MarketingBar.propTypes = {
  bannerType: PropTypes.oneOf(["split", "single"]),
  links: PropTypes.array,
  target: PropTypes.string,
  location: PropTypes.string,
}

MarketingBar.defaultProps = {
  bannerType: "single",
  links: ["/"],
  target: "_self",
}
export default MarketingBar
